/** Docs (UA): https://prostopay.atlassian.net/wiki/spaces/SW/pages/1903853583 — Знижки */

import { useTranslation } from 'react-i18next';
import { PriceBox } from '../../../../shared/ui';
import { CampaignBlock } from './CampaignBlock/CampaignBlock';
import styles from './PriceDisplay.module.css';

interface PriceDisplayProps {
    currencyCode: string;
    className?: string;
    /** Extra class for the campaign block — lets a host constrain its width. */
    campaignClassName?: string;
    /** Post-discount price (currency units) — the big number that always renders. */
    totalAmount: number;
    /** Pre-discount price (currency units). When > discountedAmount AND a discountPercentage is given, the discount block renders. */
    originalAmount?: number;
    /** Pre-computed `originalAmount − discountedAmount`. Required only when the discount block renders. */
    savings?: number;
    /** Discount % — drives the badge label, gates the discount block. */
    discountPercentage?: number | null;
    /** Campaign message under the discount block. */
    campaignMessage?: string | null;
    /** Happy Hours window; yellow variant when current local time falls inside. */
    startHour?: number | null;
    endHour?: number | null;
    isBadgeVisible?: boolean;
}

export const PriceDisplay = ({
    currencyCode,
    className,
    campaignClassName,
    totalAmount,
    originalAmount,
    savings,
    discountPercentage,
    campaignMessage,
    startHour,
    endHour,
    isBadgeVisible = true,
}: PriceDisplayProps) => {
    const { t } = useTranslation();
    const currencyLabel = t(`Currency.${currencyCode}`);

    const hasDiscount =
        typeof originalAmount === 'number'
        && originalAmount > 0
        && totalAmount > 0
        && originalAmount > totalAmount
        && Boolean(discountPercentage && discountPercentage > 0);

    return (
        <>
            {hasDiscount && (
                <CampaignBlock
                    className={campaignClassName}
                    currencyLabel={currencyLabel}
                    originalAmount={originalAmount as number}
                    savings={savings}
                    discountPercentage={discountPercentage}
                    campaignMessage={campaignMessage}
                    startHour={startHour}
                    endHour={endHour}
                    isBadgeVisible={isBadgeVisible}
                />
            )}

            <PriceBox
                className={`${hasDiscount ? styles.priceDiscounted : ''}${className ? ` ${className}` : ''}`}
            >
                <span id="price">{totalAmount.toFixed(2)}</span>{' '}
                {currencyLabel}
            </PriceBox>
        </>
    );
};
